import {
  SubscriptionRegistration,
  RedirectToSubscriptionRegistrationPage,
  RedirectToSubscribe,
} from "@pages/registration/SubscriptionRegistration";
import { AppRoute } from "./types";

export const registrationRoutes: AppRoute[] = [
  {
    path: "/subscribe/mls/:subscriptionId?/:token?",
    element: <RedirectToSubscriptionRegistrationPage />,
  },
  {
    path: "/subscribe/partner/:partnerId/:subscriptionId?/:token?",
    element: <SubscriptionRegistration />,
  },
  {
    path: "/subscribe/partner",
    element: <RedirectToSubscribe />,
  },
  {
    path: "/subscribe/:subscriptionId?/:token?",
    element: <SubscriptionRegistration />,
  },
];
